import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const AREATYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.AreaType.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('code', 'Entity.AreaType.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
];

export const AREATYPE_CONFIG = {
  entityName: 'AreaType',
  localizationKey: 'Planning::Entity.AreaType',
  fields: AREATYPE_FIELDS,
  permission: 'PlanningLocation.AreaTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Location + MENU_NAME_SUFFIX,
};
